import { render, staticRenderFns } from "./AgreementDocumentNewRevision.vue?vue&type=template&id=37aec865&"
import script from "./AgreementDocumentNewRevision.vue?vue&type=script&lang=js&"
export * from "./AgreementDocumentNewRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports